module.exports = {
  card: name => `congrex/list/card/${name}`,
  container: 'congrex/list/container'
}
